export default __webpack_public_path__ + "static/media/playlist.ed6cdebf.svg";